<template>
    <div :class="[$style.__exit__confirm, displayLoading ? [$style.__active] : '']">
        <div :class="[$style.__outer]">
        </div>
        <div :class="[$style.__exit__container]">
            <img :src="icon.loading" width="30" alt="">
        </div>
    </div>
</template>

<script>
import Chathub from '@/apis/chathub';
import Socket from '@/sockets/Socket';
import EventBus from '@/functions/EventBus'

let chathubObject = new Chathub;

export default {
    
    props: {
        displayLoading: {
            type : Boolean,
            default : false
        },
      
    },
    data() {
        return {
            icon : {
                loading : process.env.NODE_ENV == 'local' ? require('@/medias/images/icon/loading.gif') : process.env.VUE_APP_STORAGE + '/vue/img/icon/loading.gif'
            },
        }
    },
   
    methods : {

    }
}
</script>

<style lang="scss" module scoped>
    .__exit__confirm {
        display: none;
        &.__active {
            display :block;
        }
        .__outer {
            background: #000;
            height: 100%;
            width : 100%;
            bottom : 0;
            position: absolute;
            z-index: 9999;
            opacity: 0.5;
        }
        .__exit__container {
            position: absolute;
            z-index: 10000;
            background : none;
            bottom : 30%;
            width: 100%;
            margin : 20px 0px;
            text-align: center;
            border-radius: 8px;
            padding : 24px;
            .__header {
                h5 {
                    font-size: 14px !important;
                    font-weight: 500 !important;
                }
                margin-bottom: 20px
            }
            .__body {
                font-size: 13px !important;
                font-style: normal;
                line-height: 16px;
                margin-bottom: 30px
            }
            .__footer {
                .__btn {
                    font-size: 13px !important;
                    font-style: normal;
                    line-height: 16px;
                    width : 100%;
                }
            }
        }
    }
    @media screen and (min-width: 769px) {
        .__exit__confirm {
            .__exit__container {
                bottom : 30%;
            }

        }
    }
</style>